export const messages = {
  en: {
    wechatSubscribe: {
      page: {
        title: 'Subscribed Users',
        subtitle: 'Users who follow the community official WeChat account, synced from the WeChat platform',
        empty: 'No subscribed user records',
        loadFailed: 'Failed to load subscribed users, please retry',
        tip: 'Syncing pulls data from the WeChat official platform; avoid frequent syncs to prevent account restrictions'
      },
      title: 'Subscribed Users',
      type: 'Type',
      openId: 'Open ID',
      unionId: 'Union ID',
      syncTime: 'Sync Time',
      wechat: 'WeChat',
      other: 'Other',
      syncUser: 'Sync Users',
      confirmTitle: 'Please confirm your operation!',
      syncConfirmText: 'Confirm to sync subscribed users data from WeChat official account. Please do not use frequently to avoid being banned by WeChat. Please refresh to view sync records after submission.',
      syncSuccess: 'Sync successfully',
      syncError: 'Sync failed',
      fetchError: 'Failed to fetch subscribed users'
    }
  },
  zh: {
    wechatSubscribe: {
      page: {
        title: '关注用户',
        subtitle: '关注小区公众号的用户，由微信平台同步而来',
        empty: '暂无关注用户记录',
        loadFailed: '关注用户加载失败，请重试',
        tip: '同步操作将从微信公众平台拉取数据，请勿频繁同步以免公众号被封禁'
      },
      title: '关注用户',
      type: '类型',
      openId: 'Open ID',
      unionId: 'Union ID',
      syncTime: '同步时间',
      wechat: '微信',
      other: '其他',
      syncUser: '同步用户',
      confirmTitle: '请确认您的操作!',
      syncConfirmText: '确定从公众号同步关注用户数据，请不要频繁使用，以免微信公众号封禁，提交后请刷新查看同步记录',
      syncSuccess: '同步成功',
      syncError: '同步失败',
      fetchError: '获取关注用户失败'
    }
  }
}
